import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubblePlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBubblePlus"><Path d="M12 7.49998L12 11M12 11L12 14.5M12 11H8.5M12 11L15.5 11M3.5 3.5L20.5 3.50002V18.5H15.0155L11.9979 21L9.0155 18.5L3.5 18.5V3.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBubblePlus;
